import React from 'react';
import './Certificate.css';
import iso from "../../../Gemco-Website-Images/Homepage/iso.png";
import dubaimunicipality from '../../../Gemco-Website-Images/About-Us/dubai_municipality.png';

const Certificate = () => {
  return (
    <div className='container wp_certificate_wrap'>
      <h1>Certifications & Approvals</h1>
    <div className="wp_certificate mb-4">
      <div>
        <div class="iso-grid">
            <div class="iso-image">
                <img src={iso} alt="ISO Image" />
            </div>

            <div class="iso-content">
                <h2>ISO Certification</h2>
                <p>
                    We provide high-quality ISO certified services with industry
                    standards and professional support for all projects.
                </p>
            </div>
        </div>
    </div>

    <div>
        <div class="iso-grid">
            <div class="iso-image">
                <img src={dubaimunicipality} alt="ISO Image" />
            </div>

            <div class="iso-content">
                <h2>Quality Assurance</h2>
                <p>
                    Our team ensures strict quality checks and reliable solutions
                    for residential, commercial, and industrial projects.
                </p>
            </div>
        </div>
    </div>
    </div>
   </div>
  )
}

export default Certificate